import { render } from "./CRMDepartmentHigh.vue?vue&type=template&id=d9264b3e&scoped=true"
import script from "./CRMDepartmentHigh.vue?vue&type=script&lang=js"
export * from "./CRMDepartmentHigh.vue?vue&type=script&lang=js"

import "./CRMDepartmentHigh.vue?vue&type=style&index=0&id=d9264b3e&scoped=true&lang=css"
import "./CRMDepartmentHigh.vue?vue&type=style&index=1&id=d9264b3e&lang=css"
script.render = render
script.__scopeId = "data-v-d9264b3e"

export default script